import prestashop from "./prestashop";

declare global {
    interface Window {
        selectDeliveryOption?: (arg: any) => void;
    }
}

const initPlikisCheckout = () => {
    //if body doesn't have ID "checkout", return
    if (!document.body.id || document.body.id !== 'checkout') {
        return;
    }
    
    //let's hide postcode, address, city fields in invoice address if delivery option is pickup
    const postcodeInvoiceField = document.querySelector<HTMLInputElement>('form.address-fields input[name="postcode"]');
    const postcodeInvoiceWrap = document.querySelector<HTMLElement>('form.address-fields .form-group.postcode');
    
    const addressInvoiceField = document.querySelector<HTMLInputElement>('form.address-fields input[name="address1"]');
    const addressInvoiceWrap = document.querySelector<HTMLElement>('form.address-fields .form-group.address1');
    
    const cityInvoiceField = document.querySelector<HTMLInputElement>('form.address-fields input[name="city"]');
    const cityInvoiceWrap = document.querySelector<HTMLElement>('form.address-fields .form-group.city');
    
    const setPostcodeFieldVisibility = () => {
        if (!postcodeInvoiceField) {
            return;
        }
        //check if selected delivery option is pickup (contains "Atsiimsiu parduotuvėje" in name)
        const selectedDeliveryOptionLabel = document.querySelector('.delivery-options-list .delivery-option.selected .delivery-option-label');

        if (selectedDeliveryOptionLabel && selectedDeliveryOptionLabel.textContent?.includes('Atsiimsiu parduotuvėje')) {
            //if it is, make postcode field not required
            postcodeInvoiceField.required = false;
            postcodeInvoiceField.classList.remove('required');
            postcodeInvoiceWrap?.querySelector('label')?.classList.remove('required');
        } else {
            //if it is not, make postcode field required
            postcodeInvoiceField.required = true;
            postcodeInvoiceField.classList.add('required');
            postcodeInvoiceWrap?.querySelector('label')?.classList.add('required');
            
        }
    };
    
    const setAddressFieldVisibility = () => {
        if (!addressInvoiceField) {
            return;
        }
        //check if selected delivery option is pickup (contains "Atsiimsiu parduotuvėje" in name)
        const selectedDeliveryOptionLabel = document.querySelector('.delivery-options-list .delivery-option.selected .delivery-option-label');
        console.log('Selected delivery option:', selectedDeliveryOptionLabel);
        if (selectedDeliveryOptionLabel && selectedDeliveryOptionLabel.textContent?.includes('Atsiimsiu parduotuvėje')) {
            //if it is, make address field not required
            addressInvoiceField.required = false;
            addressInvoiceField.classList.remove('required');
            addressInvoiceWrap?.querySelector('label')?.classList.remove('required');
            console.log(addressInvoiceWrap?.querySelector('label'));
        } else {
            //if it is not, make address field required
            addressInvoiceField.required = true;
            addressInvoiceField.classList.add('required');
            addressInvoiceWrap?.querySelector('label')?.classList.add('required');
            
        }
    };
    
    const setCityFieldVisibility = () => {
        if (!cityInvoiceField) {
            return;
        }
        //check if selected delivery option is pickup (contains "Atsiimsiu parduotuvėje" in name)
        const selectedDeliveryOptionLabel = document.querySelector('.delivery-options-list .delivery-option.selected .delivery-option-label');
        if (selectedDeliveryOptionLabel && selectedDeliveryOptionLabel.textContent?.includes('Atsiimsiu parduotuvėje')) {
            //if it is, make city field not required
            cityInvoiceField.required = false;
            cityInvoiceField.classList.remove('required');
            cityInvoiceWrap?.querySelector('label')?.classList.remove('required');
        } else {
            //if it is not, make city field required
            cityInvoiceField.required = true;
            cityInvoiceField.classList.add('required');
            cityInvoiceWrap?.querySelector('label')?.classList.add('required');
        }
    };
    
    
    setPostcodeFieldVisibility();
    setAddressFieldVisibility();
    setCityFieldVisibility();
    
    window.prestashop.on('thecheckout_updateDeliveryOption', function () {
        setPostcodeFieldVisibility();
        setAddressFieldVisibility();
        setCityFieldVisibility();
    });
    
    console.log('Plikis checkout initialized');
    //on '#js-delivery select' trigger selectDeliveryOption
    document.body.addEventListener('change', function (event) {
        const target = event.target as HTMLElement;
        if (target && target.matches('#js-delivery select')) {
            console.log('Delivery option changed:', (target as HTMLSelectElement).value);
            //thecheckout function
            if (typeof window.selectDeliveryOption !== 'function') {
                return;
            }
            window.selectDeliveryOption($('#js-delivery'));
        }
    });
     
}
export default initPlikisCheckout;